module.exports = __webpack_public_path__ + "static/media/coronavirus_prevention_icon.ecbe58ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/assets/game_icons/coronavirus_prevention_icon.png
// module id = 299
// module chunks = 0